export default "__VITE_ASSET__BNm$5Nys__"